import { $onload } from '../../../../utils/dom.ts';
import formSubmitHandler from '../../../form-submit-handlers/index.ts';

$onload(
    '.view-components-blocks-GoogleSheetsForm',
    HTMLElement,
    ($el, { $OrThrow }) => {
        formSubmitHandler({
            handler: JSON.parse($el.dataset.handler || ''),
            $form: $OrThrow('-form', HTMLFormElement),
            $message: $OrThrow('-message', HTMLElement),
        });
    },
);
